import {
  type FC,
  type Dispatch,
  type SetStateAction,
  type ReactNode,
  useEffect,
} from 'react';
import { topSectionHeight } from '../../layouts/theme';
import getScrollPosition from '../../../utils/getScrollPosition';
import * as styles from './StickyHeader.css';
import Headroom from 'react-headroom';
import { MobileFilterSection } from '../MobileFilterSection';
import { useStores } from '../../../utils/hooks/useStores';
import {
  type PageTab,
  PageTabs,
} from 'src/App/CandidateManagementPage/PageTabs';
import { useAppConfig } from 'src/constants/AppConfig/AppConfigProvider';

interface MobileStickyHeaderProps {
  isAtTopOfPage: boolean;
  setIsAtTopOfPage: Dispatch<SetStateAction<boolean>>;
  selectedPageTab: PageTab;
  setSelectedPageTab: (tab: PageTab) => void;
  isStickyOnDesktop: boolean;
  setIsStickyOnDesktop: Dispatch<SetStateAction<boolean>>;
  employerHeader: ReactNode;
}

export const MobileStickyHeader: FC<MobileStickyHeaderProps> = ({
  isAtTopOfPage,
  isStickyOnDesktop,
  selectedPageTab,
  setIsStickyOnDesktop,
  setSelectedPageTab,
  setIsAtTopOfPage,
  employerHeader,
}) => {
  const { jobApplicationStore, jobStore } = useStores();
  const { language } = useAppConfig();

  const shouldShowTabs = jobStore.job.isActive;

  const onStickyTopChanged = () => {
    const shouldHide = getScrollPosition() <= topSectionHeight;
    setIsAtTopOfPage(shouldHide);
  };

  const onPin = () => {
    onStickyTopChanged();
  };

  const onUnpin = () => {
    onStickyTopChanged();
  };

  useEffect(() => {
    onStickyTopChanged();
    window.addEventListener('scroll', onStickyTopChanged);
    return function cleanup() {
      window.removeEventListener('scroll', onStickyTopChanged);
    };
  });

  return (
    <Headroom pinStart={topSectionHeight} onPin={onPin} onUnpin={onUnpin}>
      <div className={styles.stickyHeaderRoomWrapper}>
        {employerHeader}
        {!isAtTopOfPage && (
          <>
            {shouldShowTabs && (
              <PageTabs
                isStickyOnDesktop={isStickyOnDesktop}
                selectedPageTab={selectedPageTab}
                setIsStickyOnDesktop={setIsStickyOnDesktop}
                setSelectedPageTab={setSelectedPageTab}
                showRecommendedCandidates={shouldShowTabs}
                jobId={jobApplicationStore.jobId}
                onApplicationsTabClick={() =>
                  jobApplicationStore.loadJobApplications({
                    language,
                  })
                }
              />
            )}
            <MobileFilterSection jobApplicationStore={jobApplicationStore} />
          </>
        )}
      </div>
    </Headroom>
  );
};
